import styles from "./RecordButton.module.css"

const RecordButton = ({onStart, onStop, isPreviewing}) => {
  return (
    <div className={styles.recordOuter}>
        <button onClick={onStart} className={styles.recordStartOuter} hidden={!isPreviewing}>&nbsp;</button>
        <button onClick={onStop} className={styles.recordStopOuter} hidden={isPreviewing}><div className={`${styles.record} ${styles.recordStop}`}>&nbsp;</div></button>
    </div>
  )
};
export default RecordButton;